/** POST hidden form to PayFast (server returns payfastUrl + signed fields). */
export function submitPayFastCheckout(data: {
  payfastUrl?: string;
  fields?: Record<string, string>;
}): void {
  if (!data.payfastUrl || !data.fields) {
    throw new Error("Invalid checkout response");
  }
  const form = document.createElement("form");
  form.method = "POST";
  form.action = data.payfastUrl;
  for (const [key, value] of Object.entries(data.fields)) {
    if (key === "signature" || (value !== "" && value != null)) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = value;
      form.appendChild(input);
    }
  }
  document.body.appendChild(form);
  form.submit();
}
